import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  user?: Record<string, unknown>;
}

const initialState: UserState = {};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<Record<string, unknown>>) => {
      state.user = action.payload;
    },
    logout: (state) => {
      state.user = {};
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  login,
  logout
} = userSlice.actions;

export default userSlice.reducer;
